// extracted by mini-css-extract-plugin
export default {"root":"SimulationSelect_root__lhd5b","wrapper":"SimulationSelect_wrapper__USG3i"};